import axios from 'axios';
import { message } from 'ant-design-vue';
import config from '@/config'; // eslint-disable-line import/extensions
import { isLaunchInProgressError } from '@/helpers/launchWithConfirm';
import { isRenderRevisionChoiceError } from '@/helpers/renderRevisionChoice';

const showErrorMessage = (text) => {
  message.error({
    content: text,
    duration: 5,
  });
};

const isHandledByCaller = (error) => (error?.response?.status === 403 && error?.response?.data?.message)
  || isLaunchInProgressError(error)
  || isRenderRevisionChoiceError(error);

const buildErrorMessage = (error) => {
  let messageText = error?.response?.data?.message;

  if (error.config && error.config.url) {
    messageText += `\nRequest URL: ${error.config.url}`;
  }

  return `${messageText}\nPage URL: ${window.location.pathname}`;
};

const handleResponseError = (error) => {
  if (error.config?.silent) throw error;

  if (isHandledByCaller(error)) {
    throw error;
  }

  const messageText = buildErrorMessage(error);

  if (messageText) {
    showErrorMessage(messageText);
  }

  if (error?.response?.status >= 500) {
    window.location.href = `/error?message=${encodeURIComponent(messageText)}`;
  }
  throw error;
};

export const createHttpClient = () => {
  const client = axios.create({
    baseURL: config.apiUrl,
    headers: { Accept: 'application/json' },
  });

  client.interceptors.response.use((response) => response, handleResponseError);

  return client;
};

export const httpClient = createHttpClient();

export const fileDownloadConfig = {
  headers: { Accept: '*' },
  responseType: 'blob',
};
